var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCafeMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 65,
    viewBox: "0 0 59 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1396_5036)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4082 5C10.9736 5 9 6.97361 9 9.40817V41.7347C9 44.1693 10.9736 46.1429 13.4082 46.1429H25.6125L27.6626 49.6939C28.511 51.1633 30.6319 51.1633 31.4802 49.6939L33.5304 46.1429H45.7347C48.1693 46.1429 50.1429 44.1693 50.1429 41.7347V9.40816C50.1429 6.9736 48.1692 5 45.7347 5H13.4082Z",
    fill: "#C86000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1396_5036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 12.7143H21C19.4286 12.7143 18.1429 14 18.1429 15.5714V27C18.1429 30.1572 20.7 32.7143 23.8571 32.7143H32.4286C35.5857 32.7143 38.1429 30.1572 38.1429 27V22.7143H41C42.5714 22.7143 43.8571 21.4286 43.8571 19.8572V15.5714C43.8571 14 42.5714 12.7143 41 12.7143ZM41 19.8572H38.1429V15.5714H41V19.8572ZM16.7143 38.4286H39.5714C40.3571 38.4286 41 37.7857 41 37C41 36.2143 40.3571 35.5714 39.5714 35.5714H16.7143C15.9286 35.5714 15.2857 36.2143 15.2857 37C15.2857 37.7857 15.9286 38.4286 16.7143 38.4286Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1396_5036",
    x: 0.183673,
    y: 0.591836,
    width: 58.7755,
    height: 65.6327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1396_5036"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1396_5036",
    result: "effect2_dropShadow_1396_5036"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1396_5036",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1396_5036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2857,
    height: 34.2857,
    fill: "white",
    transform: "translate(12.4286 8.42853)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafeMarker);
export default __webpack_public_path__ + "static/media/cafe_marker.1b218cc06595fc496f97c727437b0015.svg";
export { ForwardRef as ReactComponent };